import Bowser from "bowser";
import { v4 as uuidv4 } from "uuid";
import { getToken } from "firebase/messaging";
import { firebaseMessaging } from "../firebase/client-app";
import { config } from "../config";
import { setCookie, getCookie } from "cookies-next";

export const fetchDeviceInfoAndFcmToken = async () => {
  const deviceInfo = getDeviceInfo();
  if (!deviceInfo) return null;

  const fcmToken = (await fetchFCMToken()) || "";

  return { deviceInfo, fcmToken };
};

const getDeviceInfo = () => {
  if (typeof window === "undefined") return null;

  const browser = Bowser.getParser(window.navigator.userAgent);
  const browserInfo = browser.getBrowser();
  const os = browser.getOS();
  const deviceId = getOrGenerateDeviceId();

  return {
    device_id: deviceId,
    device_type: detectPlatform(),
    browser_name: browserInfo.name || "",
    browser_version: browserInfo.version || "",
    os_version: os.version?.trim() || "",
  };
};

const detectPlatform = (): number => {
  const userAgent = navigator.userAgent;

  if (/iPhone|iPad|iPod/i.test(userAgent)) return 1;
  if (/Mobi|Android/i.test(userAgent)) return 2;

  return 3; // Desktop
};

const getOrGenerateDeviceId = (): string => {
  const deviceId = getCookie("device_id");

  if (deviceId) return deviceId.toString();

  const newDeviceId = uuidv4();
  setCookie("device_id", newDeviceId, {
    maxAge: 60 * 60 * 24 * 365, // 1 year
    path: "/",
    secure: true,
    sameSite: "strict",
  });

  return newDeviceId;
};

const fetchFCMToken = async (): Promise<string | null> => {
  if (typeof window === "undefined") return null;

  try {
    const messaging = await firebaseMessaging;
    if (!messaging) return null;

    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js",
    );

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    return await getToken(messaging, {
      vapidKey: config.VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
  } catch {
    return null;
  }
};
